import { TRANSLATIONS_SET } from '../actionConstants';
import { Action } from '../../generalTypes';
import type { IExtendedTranslations } from './translationsTypes';

export const setTranslations = (
  translationsData: IExtendedTranslations
): Action<IExtendedTranslations> => ({
  type: TRANSLATIONS_SET,
  payload: translationsData,
});
